import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { IPetWithAge, IWellnessPlanDetails } from "../../../services/wellness-plan/wellness-plan.interface";
import React, { useEffect, useState } from "react";

import { AvatarCustom } from "../../../components";
import { CloseIcon } from "../../../components/Icons";
import { fromUnixToFormattedVisitdateStr } from "../../../utils/unix-timestamp";
import { useFetchWellnessPlanByPetId } from "../../../services/wellness-plan/wellness-plan.service";
import { useModal } from "../../../context/ModalContext";
import { useSearchParams } from "react-router-dom";

const WellnessUpdateConfirmationModal = () => {
  const { closeModal } = useModal();
  const [searchParams] = useSearchParams();
  const petId = searchParams.get("id");
  const { getWellnessPlanByPetId, data } = useFetchWellnessPlanByPetId();
  const [petDetails, setPetDetails] = useState<IPetWithAge>();
  const [petWellnessDetails, setWellnessPetDetails] = useState<IWellnessPlanDetails>();


  useEffect(()=>{
    petId && getWellnessPlanByPetId(petId);
  }, [petId]);

  useEffect(()=>{
    if (data) {
      setWellnessPetDetails(data?.wellnessPlanDetails[0]);
      setPetDetails(data.pet);
    }
  }, [data]);


  return (
    <div className="h-full">
      <div className="flex justify-end">
        <CloseIcon
          onClick={closeModal}
          className="text-light-black cursor-pointer mt-1"
        />
      </div>
      <div className="flex flex-col gap-3 justify-center items-center h-[90%] text-center px-6">
        <AvatarCustom
          image={petDetails?.image}
          name={petDetails?.name}
          width={80}
          height={80}
          isWellnessMember={petDetails?.isWellnessplan}
        />
        <Typography className="font-semibold !text-2xl">{data?.planName} Renewal
             for <span className="capitalize">{petDetails?.name}</span> has been canceled</Typography>
        <div className="w-full bg-taupe-1">
          <Typography variant="body1">We’ve sent you a confirmation email</Typography>
        </div>

        <Typography variant="body1">
          <span className="capitalize">{petDetails?.name}</span>’s current {data?.planName} will remain active
             until<br/>{petWellnessDetails && fromUnixToFormattedVisitdateStr(+petWellnessDetails?.endDate)}
          {" "}and will not be renewed. </Typography>
      </div>

      <Box className="!sticky !bottom-0 !bg-gray-2 w-full pt-8">

        <Button variant="outlined" type="submit" onClick={closeModal}
          className="!normal-case !font-semibold !border !border-taupe-2 !bg-gray-3 !w-full">
          {!petDetails ? <CircularProgress color="inherit" size={20}/>:
            "Done"}
        </Button>
      </Box>
    </div>
  );
};

export default WellnessUpdateConfirmationModal;
